<template>
    <div class="index-page">
        <div class="banner" @click="clickBanner">
            <div class="swiper-section">
                <template v-if="swiperDataList.length">
                    <swiper :options="swiperOption" @slideChangeTransitionStart="slideChangeTransitionStart">
                        <swiper-slide v-for="item in swiperDataList" :key="item.id" class="swiper-no-swiping">
                            <template v-if="showImgOrVideo(item).type === 'img'">
                                <div class="swiper-img">
                                    <lazy-image v-if="showImgOrVideo(item).url" :style="{ 'border-radius': '0.375rem' }" :src="showImgOrVideo(item).url"></lazy-image>
                                </div>
                            </template>
                            <template v-else>
                                <div class="swiper-video">
                                    <video :src="showImgOrVideo(item).url" muted loop autoplay></video>
                                </div>
                            </template>
                        </swiper-slide>
                    </swiper>
                </template>
            </div>
            <div class="cover-bg">
                <div class="left"></div>
                <div class="right"></div>
                <div class="bottom"></div>
                <div class="center"></div>
            </div>
            <div class="cover-section">
                <div class="cover-inner">
                    <div class="left-info">
                        <div class="game-cn-name">{{ leftGameInfo.zh_name }}</div>
                        <div class="game-english-name">{{ leftGameInfo.en_name }}</div>
                        <!-- 广告关联了游戏 -->
                        <template v-if="activeSwiper.g_id">
                            <!-- 显示价格 -->
                            <template v-if="leftGameInfo.type === 1">
                                <div class="price-wrap">
                                    <div class="icon">
                                        <p class="p1">直降</p>
                                        <p class="p2">{{ showDiscount }}%</p>
                                    </div>
                                    <span class="yuan">￥</span>
                                    <span class="cur-price">{{ leftGameInfo.enable_sp_low_cur_price }}</span>
                                    <div class="steam-price">
                                        <p>steam售价</p>
                                        <p class="p2">原价:￥{{ leftGameInfo.steam_price }}</p>
                                    </div>
                                </div>
                            </template>
                            <!-- 显示"会员免费玩文字" -->
                            <template v-if="leftGameInfo.type === 2">
                                <div class="free-wrap">
                                    <div class="icon">
                                        <p>会员</p>
                                        <p>免费玩</p>
                                    </div>
                                    <div class="steam-price">
                                        <p>steam售价</p>
                                        <p class="p2">原价:￥{{ leftGameInfo.steam_price }}</p>
                                    </div>
                                </div>
                            </template>
                            <!-- 立即购买和会员免费玩按钮 -->
                            <div class="btn-section" v-if="leftGameInfo.type !== 0">
                                <div data-agl-cvt="6" @click.stop="dlBox(3, 'click_single')" class="btn buy">{{ leftGameInfo.type === 2 ? '立即游玩' : '立即购买' }}</div>
                                <div data-agl-cvt="6" @click.stop="dlBox(3, 'click_vip')" class="btn free">会员免费玩</div>
                            </div>
                        </template>
                    </div>
                    <div class="right-tab">
                        <div class="item ellipsis" @click="changeSwiper(index, $event)" :class="{ active: index == activeSwiperIndex }" v-for="(item, index) in swiperDataList" :key="item.id">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="intro-img" @click="dlBox(3, $event)" data-agl-cvt="6"></div>
        <div class="search-section">
            <div class="tip"></div>
            <div class="search-wrap">
                <search-input :width="372" @input="handlerInput" :empty-can-search="true" @searchClick="handlerSearch" @clear="resetSearchFilter"></search-input>
            </div>
            <div class="game-inner">
                <RecGameItem class="item" page="index" type="game-index" v-for="item in gameList" :key="item.id" :game-info="item"> </RecGameItem>
                <div class="loading-wrap" v-if="loadingFinish">
                    <DataLoader :loading="loading" :data="gameList"></DataLoader>
                </div>
            </div>
            <div class="page-section">
                <Page class="pagination" :hideOnSinglePage="true" placement="center" :total="total" :pageSize="query.size" :current="query.page" @change="changePaging"> </Page>
            </div>
        </div>
    </div>
</template>
<script>
import { gameDatabase, getFreeGameList } from '@/http/api/game.js'
import { getAdConfigs } from '@/http/api/common.js'
import { cancelRequest } from '@/http'
import { Decimal } from 'decimal.js'

export default {
    name: 'IndexPage',
    data() {
        const that = this
        return {
            query: {
                page: 1,
                size: 16,
                name: '',
                mode: 1
            },
            total: 0,
            gameList: [],
            loading: false,
            loadingFinish: false,
            loadingError: false,
            keywords: '',
            swiperDataList: [],
            swiperOption: {
                initialSlide: 0,
                direction: 'vertical',
                loop: false,
                touchMove: false,
                autoplay: {
                    delay: 50000,
                    disableOnInteraction: false
                },
                on: {
                    init: function () {
                        that.swiperInstance = this
                    }
                }
            },
            activeSwiperIndex: 0,
            activeSwiper: {},
            leftGameInfo: {
                type: 0, // 1--有最低价和现价 2--》显示'会员免费玩'文字
                zh_name: '',
                en_name: '',
                steam_price: '',
                enable_sp_low_cur_price: '' // 上架规格里面现价最低的
            }
        }
    },
    computed: {
        showImgOrVideo() {
            return (item) => {
                let info = {
                    type: '',
                    url: ''
                }
                if (!item.g_id) {
                    info.type = 'img'
                    info.url = this.filterImg(item.pic, '1920x710')
                } else {
                    const screenshot_list = item.game_information?.screenshot_list || []
                    const firstVideo = screenshot_list.find((v) => v.type == 2)
                    if (firstVideo) {
                        info.type = 'video'
                        info.url = firstVideo.video ? this.filterImg(firstVideo.video) : ''
                    } else {
                        info.type = 'img'
                        info.url = screenshot_list[0]?.url ? this.filterImg(screenshot_list[0].url, '1920x710') : ''
                    }
                }
                return info
            }
        },
        showDiscount() {
            const { enable_sp_low_cur_price, steam_price } = this.leftGameInfo
            let discount = '0'
            if (steam_price && enable_sp_low_cur_price) {
                // 差价
                const priceDiff = Decimal(steam_price).minus(enable_sp_low_cur_price)
                // steam_price为0时或者差价小于等于0，显示0
                if (Decimal(steam_price).eq(0) || priceDiff.lte(Decimal(0))) {
                    discount = 0
                } else {
                    // 计算折扣 保留一位小数
                    discount = priceDiff.dividedBy(Decimal(steam_price)).times(100).toNumber().toFixed(1)
                }
            }
            return discount
        }
    },
    watch: {
        keywords: function (cur, pre) {
            if (pre && !cur) {
                this.handlerSearch('')
            }
        },
        activeSwiperIndex: {
            immediate: true,
            deep: true,
            handler(value) {
                if (this.swiperDataList[value]) {
                    this.activeSwiper = this.swiperDataList[value]
                    this.leftGameInfo.type = 0 // 重置类型
                    this.calcGameInfo(this.activeSwiper)
                }
            }
        }
    },
    created() {
        this.gameDatabase('first')
        this.getAdConfigs()
    },
    methods: {
        handlerSearch(value) {
            cancelRequest('/box/goods/list')
            cancelRequest('/box/boxFamily/gamefree/list')
            const tempPage = this.query.page
            this.loading = false
            this.loadingFinish = false
            this.loadingError = false
            this.query.page = 1 // 在非第一页搜索时，这里会触发changePaging
            this.query.name = value
            if (tempPage == 1) {
                this.gameDatabase()
            }
        },
        resetSearchFilter() {
            this.handlerSearch('')
        },
        gameDatabase(type) {
            this.loading = true
            gameDatabase(this.query)
                .then(async (res) => {
                    this.loading = false

                    if (res.code == 200) {
                        this.loadingError = false
                        if (Array.isArray(res.data.list)) {
                            const { list, total } = res.data
                            this.total = total
                            this.gameList = [...list.map((v) => ({ ...v, is_free: -1, isCompare: false }))]
                            if (this.query.size > res.data.list.length) {
                                this.loadingFinish = true
                            }
                            let tempGameIds = Array.from(new Set(list.map((v) => v.game_id)))
                            this.getFreeGameList(tempGameIds)

                            // 切换分页时，向上滚动
                            if (type !== 'first') {
                                window.scrollTo({
                                    top: 710,
                                    left: 0,
                                    behavior: 'smooth'
                                })
                            }
                        }
                    } else {
                        this.loadingError = true
                    }
                })
                .catch(() => {
                    this.loading = false
                    this.loadingError = true
                })
        },
        getFreeGameList(gameIds) {
            let tempGameIds = `[${gameIds.join(',')}]`
            getFreeGameList({ page: 1, size: 60, gameIds: tempGameIds }).then((res) => {
                if ((res.code = 200 && Array.isArray(res.data.list))) {
                    let list = res.data.list
                    this.gameList.forEach((v1) => {
                        if (!v1.isCompare) {
                            // 只查找没有比较过的，并且是有goods_id的
                            let index = list.findIndex((v2) => v1.game_id == v2.game_id)
                            if (index > -1) {
                                v1.is_free = 1
                            } else {
                                v1.is_free = 0
                            }
                            v1.isCompare = true
                        }
                    })
                }
            })
        },
        changePaging(params) {
            cancelRequest('/box/boxFamily/information/list')
            cancelRequest('/box/boxFamily/gamefree/list')
            this.loading = false
            this.loadingFinish = false
            this.loadingError = false
            this.query.page = params.page
            this.gameDatabase()
        },
        dlBox(type, click_str) {
            if (click_str === 'click_single') {
                // 立即购买
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 13 })
            } else if (click_str === 'click_vip') {
                // 会员免费玩
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 14 })
            }
            this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: type })

            if (click_str === 'click_single' && this.leftGameInfo.type !== 2) {
                this.$BuyVipDialog.show(this.game_information)
            } else {
                // 通知到App.vue里面去下载
                this.$EventBus.$emit('app-dl')
            }
        },
        handlerInput(value) {
            this.keywords = value
        },
        calcGameInfo(item) {
            const activeSwiper = item
            this.leftGameInfo.zh_name = activeSwiper.game_information?.title || ''
            this.leftGameInfo.en_name = activeSwiper.game_information?.english_title || ''
            this.leftGameInfo.steam_price = activeSwiper.game_information?.original_price || '0.00'
            this.game_information = activeSwiper.game_information || {}

            if (activeSwiper.g_id) {
                const goods_list = activeSwiper.game_information?.goods_list || []
                if (goods_list.length) {
                    // 判断上架状态的商品里面是否有可用的规格
                    const everySpDisabled = goods_list.every((v) => !v.goodsSpecifications)
                    if (!everySpDisabled) {
                        // 获取所有的开启单独售卖的商品规格
                        const allSp = goods_list.reduce((pre, cur) => {
                            if (Array.isArray(cur.goodsSpecifications) && cur.goodsSpecifications.length) {
                                pre.push(...cur.goodsSpecifications)
                            }
                            return pre
                        }, [])
                        // 没有售卖的规格，那就显示会员免费玩
                        if (allSp.length === 0) {
                            this.leftGameInfo.type = 2
                        } else {
                            // 获取规格里面的最低价
                            const minSp = allSp.sort((a, b) => {
                                return a.current_price - b.current_price
                            })[0]

                            // 如果最低价的规格没有开启售卖，那就显示会员免费玩
                            if (minSp.is_sell !== 1) {
                                this.leftGameInfo.type = 2
                            } else {
                                this.leftGameInfo.enable_sp_low_cur_price = minSp.current_price
                                this.leftGameInfo.type = 1
                            }
                        }
                    } else {
                        this.leftGameInfo.type = 2
                    }
                }
            }
        },
        filterImg(value, size) {
            return this.$Utils.filterImgUrl(value, size)
        },
        getAdConfigs() {
            const query = {
                page: 1,
                size: 7,
                type: 15,
                is_enable: 1
            }
            getAdConfigs(query).then((res) => {
                if (res.code == 200 && Array.isArray(res.data.list)) {
                    this.swiperDataList = res.data.list
                    const firstItem = this.swiperDataList[0]
                    if (firstItem && firstItem.g_id) {
                        this.activeSwiper = firstItem
                        this.calcGameInfo(firstItem)
                    }
                }
            })
        },
        slideChangeTransitionStart() {
            this.activeSwiperIndex = this.swiperInstance.realIndex
        },
        changeSwiper(index, event) {
            event.stopPropagation()
            this.activeSwiperIndex = index
            this.swiperInstance.slideToLoop(index, 500, false)
        },
        clickSwiper(item) {
            const link = String(item.link)
            if (link) {
                if (link.startsWith('http://') || link.startsWith('https://') || link.startsWith('cgm://')) {
                    window.open(link, '_blank')
                } else {
                    // 盒子官网项目的页面地址
                    this.$router.push(item.link)
                }
            }
        },
        clickBanner() {
            const curItem = this.swiperDataList[this.activeSwiperIndex]
            if (curItem.g_id) {
                const route = this.$router.resolve({
                    path: '/landpage',
                    query: {
                        game_id: curItem.g_id
                    }
                })
                const newWindow = window.open(route.href, '_blank')
                newWindow.onload = () => {
                    newWindow.document.title = route.meta?.title || `乐速盒子官网-${curItem.game_information.title}`
                }
            } else {
                this.clickSwiper(curItem)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.index-page {
    .top-nav {
        position: fixed;
        width: 1920px;
        left: 50%;
        transform: translateX(-50%);
        height: 80px;
        background: rgba(0, 0, 0, 0.3);
        z-index: 100;

        .nav-content {
            margin: 0 auto;
            width: @main-width;

            .logo {
                margin-top: 18px;
                width: 144px;
                height: 45px;
                background: url(../../assets/logo.png) center/100% no-repeat;
            }

            .dl-btn {
                .button-linear();
                position: relative;
                left: 8px;
                margin-top: 22px;
                width: 125px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                font-weight: bold;
                font-size: 16px;
                color: @bg-color-00;
            }
        }
    }

    .banner {
        cursor: pointer;
        margin: 0 auto;
        height: 710px;
        max-width: 1920px;
        position: relative;

        .swiper-section {
            position: relative;
            width: 100%;
            height: 100%;

            /deep/ .swiper-container {
                width: 100%;
                height: 100%;

                .swiper-slide {
                    height: 710px;

                    .swiper-img {
                        height: 710px;

                        img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .swiper-video {
                        height: 710px;

                        video {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
            }
        }

        .cover-bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;

            .left {
                background-image: linear-gradient(90deg, rgba(18, 18, 18, 0.98), rgba(18, 18, 18, 0.65) 35%, transparent);
                height: 100%;
                left: 0px;
                position: absolute;
                top: 0px;
                width: 500px;
            }

            .right {
                background-image: linear-gradient(-90deg, rgba(18, 18, 18, 0.98), rgba(18, 18, 18, 0.65) 35%, transparent);
                height: 100%;
                position: absolute;
                right: 0px;
                top: 0px;
                width: 500px;
            }

            .bottom {
                background: linear-gradient(180deg, #13292500 0%, #121d23 100%);
                bottom: 0px;
                height: 240px;
                position: absolute;
                width: 100%;
            }

            .center {
                background-color: rgb(14, 26, 32);
                height: 100%;
                left: 0px;
                opacity: 0;
                position: absolute;
                top: 0px;
                transition: opacity 0.3s;
                width: 100%;
            }
        }

        .cover-section {
            position: absolute;
            left: 0;
            top: 0;
            padding-top: 80px;
            right: 0;
            width: 100%;
            z-index: 2;

            .cover-inner {
                position: relative;
                margin: 0 auto;
                height: 630px;
                width: 1320px;

                .left-info {
                    position: absolute;
                    top: 323px;
                    left: 0;

                    .game-cn-name {
                        color: rgb(255, 255, 255);
                        font-size: 40px;
                        font-weight: 700;
                        line-height: 60px;
                        height: 60px;
                    }

                    .game-english-name {
                        color: rgb(166, 166, 166);
                        font-size: 20px;
                        line-height: 30px;
                        height: 30px;
                    }

                    .price-wrap,
                    .free-wrap {
                        .steam-price {
                            padding-top: 23px;
                            color: rgb(166, 166, 166);
                            font-size: 16px;

                            p {
                                line-height: 24px;
                            }

                            .p2 {
                                text-decoration: line-through;
                            }
                        }
                    }

                    .price-wrap {
                        margin-top: 8px;
                        margin-bottom: 19px;
                        display: flex;

                        .icon {
                            margin-right: 8px;
                            width: 73px;
                            height: 83px;
                            background: url(../../assets/discount-icon.png) center/100% no-repeat;

                            .p1 {
                                padding: 21px 0 3px;
                                text-align: center;
                                color: rgb(255, 255, 255);
                                font-size: 15px;
                                font-weight: 700;
                                line-height: 20px;
                            }

                            .p2 {
                                text-align: center;
                                color: rgb(255, 255, 255);
                                font-size: 18px;
                                font-weight: 700;
                                line-height: 24px;
                            }
                        }

                        .yuan,
                        .cur-price {
                            font-weight: bold;
                            color: rgb(0, 235, 87);
                        }

                        .yuan {
                            margin-right: 4px;
                            padding-top: 39px;
                            font-size: 24px;
                            line-height: 36px;
                        }

                        .cur-price {
                            margin-right: 8px;
                            padding-top: 12px;
                            font-size: 48px;
                            font-style: normal;
                            line-height: 72px;
                        }
                    }

                    .free-wrap {
                        margin-top: 8px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;

                        .icon {
                            margin-right: 8px;
                            width: 72px;
                            height: 83px;
                            background: url(../../assets/free-icon.png) center/100% no-repeat;
                            color: #7c1900;
                            font-size: 24px;
                            font-weight: 700;
                            line-height: 51px;
                            padding-top: 24px;

                            p {
                                text-align: center;
                                font-size: 15px;
                                line-height: 20px;
                                font-weight: bold;
                            }
                        }

                        .steam-price {
                            padding-top: 0;
                        }
                    }

                    .btn-section {
                        margin-left: -12px;
                        display: flex;

                        .btn {
                            width: 258px;
                            height: 84px;
                            font-size: 24px;
                            font-weight: bold;
                            line-height: 76px;
                            text-align: center;

                            &.buy {
                                margin-right: 8px;
                                color: #ffffff;
                                background: url(../../assets/index/buy.png) left top no-repeat;

                                &:hover {
                                    background-image: url(../../assets/index/buy-h.png);
                                }
                            }

                            &.free {
                                color: #7c1900;
                                background: url(../../assets/index/free.png) left top no-repeat;

                                &:hover {
                                    background-image: url(../../assets/index/free-h.png);
                                }
                            }
                        }
                    }
                }

                .right-tab {
                    position: absolute;
                    width: 260px;
                    height: 100%;
                    top: 0;
                    right: 0;
                    padding-top: 65px;

                    .item {
                        text-align: right;
                        height: 60px;
                        line-height: 60px;
                        font-size: 18px;
                        padding-right: 10px;
                        cursor: pointer;
                        color: rgba(255, 255, 255, 0.6);

                        &.active,
                        &:hover {
                            color: #fff;
                            font-weight: bold;
                            background: url(../../assets/lunbo-active.png) center/100% no-repeat;
                        }
                    }
                }
            }
        }
    }

    .center-section {
        position: relative;

        img {
            margin: 0 auto;
            display: block;
            width: auto;
            height: 160px;
        }

        .center-content {
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -660px;
            height: 160px;
            width: @main-width;

            .center-dl-btn {
                .button-linear();
                margin: 35px 0 10px;
                border-radius: 35px;
                width: 260px;
                height: 70px;
                line-height: 70px;
                text-align: center;
                font-weight: bold;
                font-size: 20px;
                color: @bg-color-00;
            }

            .dl-tip {
                margin-left: 72px;
                line-height: 17px;
                font-size: 16px;
                color: #ffffff;
            }
        }
    }

    .intro-img {
        cursor: pointer;
        margin: 45px auto 47px;
        width: 1321px;
        height: 118px;
        background: url(../../assets/landpage/intro.png) center/100% no-repeat;

        &:hover {
            background-image: url(../../assets/landpage/intro-h.png);
        }
    }

    .search-section {
        margin: 0 auto;
        width: @main-width;

        .search-wrap {
            margin-bottom: 67px;

            /deep/ .input-wrap {
                margin: 0 auto;
                height: 38px;
                line-height: 38px;
                background: url(../../assets/index-input-bg.png) center/100% no-repeat;
            }
        }

        .tip {
            margin: 0 auto 32px;
            width: 563px;
            height: 110px;
            background: url(../../assets/play-game-icon.png) center/100% no-repeat;
        }

        .game-inner {
            display: flex;
            flex-wrap: wrap;

            .item {
                margin-right: 40px;
                margin-bottom: 40px;

                &:nth-child(4n) {
                    margin-right: 0;
                }
            }

            .loading-wrap {
                width: 100%;

                /deep/ & > div {
                    width: 100%;
                }
            }
        }

        .page-section {
            padding: 8px 0;
            margin-bottom: 42px;
        }
    }
}
</style>
